import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import './index.css';
import { AppViewportManager } from './components/common/AppViewportManager/AppViewportManager';
import { router } from './router/router';
import { AuthProvider } from './context/AuthContext';
import { PlanProvider } from './context/PlanContext';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <PlanProvider>
        <AppViewportManager>
          <RouterProvider router={router} />
        </AppViewportManager>
      </PlanProvider>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
